// extracted by mini-css-extract-plugin
export default {"container":"Products_container__W1VSt","head":"Products_head__dnnqy","left":"Products_left__UX0fx","right":"Products_right__og6Cp","description":"Products_description__WQ39y"};